import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-areaLine",
  "use": "icon-areaLine-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-areaLine\"><path d=\"M1024 767.999v64H0v-768h64v704zm-192-512c108.8-19.2 128 448 128 448H128v-288s6.4-288 224-288 153.6 294.4 288 288 83.2-140.8 192-160\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol